import always from "./always";
import curry from "./curry";
import over from "./over";

const set = curry((lens, value, data) => over(lens, always(value), data));

export default set;
